/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import msdyn365Commerce, {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric,
    ISecretValue
} from '@msdyn365-commerce/core';
import axios from 'axios';
import { IAddressRetrieved } from '../../../modules/dobbies-checkout-shipping-address';
/**
 * Input for get-categories data action.
 */
export class RetrieveAddressInput implements IActionInput {
    public addressId?: string;
    public RetrieveAddressInput(addressId?: string) {
        this.addressId = addressId;
    }

    public getCacheKey = () => `retrieveAddress`;
    public getCacheObjectType = () => 'retrieveAddressState';
    public dataCacheType = (): CacheType => 'request';
}

interface IRetrieveAPIResponseResults {
    result: IAddressRetrieved;
}
interface IRetrieveAPIResponse {
    data: IRetrieveAPIResponseResults;
}

export interface IRetreivedAddressResponse {
    town: string;
    postcode: string;
    line_1: string;
    line_2: string;
}

/**
 * Creates the input required to make the retail api call.
 * @param inputData -- Input data.
 * @returns -- IActionInput.
 */
export const createRetreiveAddressInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new RetrieveAddressInput();
};

/**
 * Calls the Retail API and returns all the categories as a flat list.
 * @param input - Input.
 * @param ctx - Context.
 * @returns - CategoryHierarchy.
 */
export async function retrieveAddressAction(input: RetrieveAddressInput, ctx: IActionContext): Promise<IRetreivedAddressResponse> {
    const headers = {
        'Content-Type': 'application/json'
    };
    // TODO Get values from secrets
    // const fetchifyKeySecret: ISecretValue | undefined = await msdyn365Commerce.secretManager?.getSecretValue('FetchifyKey', ctx.requestContext.apiSettings.baseUrl);
    // const fetchifyBaseURL: ISecretValue | undefined = await msdyn365Commerce.secretManager?.getSecretValue('FetchifyAddressURL', ctx.requestContext.apiSettings.baseUrl);

    const suggestionsResponse = await axios({
        method: 'POST',
        url: `https://api.craftyclicks.co.uk/address/1.1/retrieve`, // TODO : Get value from secrets `${fetchifyBaseURL?.value}retrieve`,
        data: {
            key: '1024c-01f0c-70dd6-06464', // TODO : Get value from secrets  fetchifyKeySecret?.value,
            country: 'gbr',
            id: input.addressId,
            extra: {
                gbr_ceremonial_counties: false
            }
        },
        headers: headers
    }).catch(error => {
        ctx.telemetry.error(error);
    });
    const retrieveAPIResponse = (suggestionsResponse as unknown) as IRetrieveAPIResponse;
    console.log('Retrieved Response', retrieveAPIResponse);
    const retrievedResponse: IRetreivedAddressResponse = {
        town: retrieveAPIResponse.data.result.locality,
        line_1: retrieveAPIResponse.data.result.line_1,
        line_2: retrieveAPIResponse.data.result.line_2,
        postcode: retrieveAPIResponse.data.result.postal_code
    };
    return retrievedResponse;
}

/**
 * The getCategory Data Action.
 */
export const retrieveAddressDataAction = createObservableDataAction({
    id: 'dobbies-retrieve-address',
    action: retrieveAddressAction as IAction<IRetreivedAddressResponse>,
    input: createRetreiveAddressInput
});

export default retrieveAddressAction;
